import React, { useContext, useState } from 'react';
import EDDialog from '../../../../../../../BaseComponents/Dialog/EDDialog';
import { TSelectedDetail } from '../../../../../../../Types/MasterDetailTypes';
import { BusinessDataFormContext } from '../../../../../_Common/Components/BusinessCollectionComponents/BusinessDataForm/BusinessDataForm';
import { ObjektVyKort } from '../../../../../_Common/Components/BusinessCollectionComponents/ObjektVyKort/ObjektVyKort';
import ObjektVy from '../../../../../_Common/Components/BusinessCollectionComponents/ObjektVy/ObjektVy';
import ObjektVySida from '../../../../../_Common/Components/BusinessCollectionComponents/ObjektVySida/ObjektVySida';
import FakturaBilderComponent from '../../../LeverantorFaktura/FakturaBilderComponent';
import FastRegGrid from '../FastRegGrid/FastRegGrid';
import { getBildFaktura } from '../../Utils/FakturadelUtils';

interface IProps {
  id: TSelectedDetail;
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

const FakturaAttestSnabbRegModal: React.FC<
  React.PropsWithChildren<IProps>
> = props => {
  const formContext = useContext(BusinessDataFormContext);
  const [fullscreen, setFullscreen] = useState(false);

  return (
    <EDDialog
      open={props.open}
      onClose={() => {
        props.setOpen(false);
      }}
      fullHeight={!fullscreen}
      fullWidth={!fullscreen}
      footerActions={[
        {
          label: 'Helskärm',
          onClick: () => {
            setFullscreen(!fullscreen);
          },
        },
        {
          label: 'Avbryt',
          onClick: () => {
            props.setOpen(false);
          },
        },
        {
          label: 'Använd',
          onClick: () => {
            props.setOpen(false);
          },
        },
      ]}
      maxWidth={false}
      fullscreen={fullscreen}
      title="Snabbregistrering"
      disableContentWrapperMargin
    >
      <ObjektVy
        nodeLoading={formContext?.formState.loading ?? false}
        sidaVidSida
        hideEditMenu
        sideBySideWidths={[4, 8]}
      >
        <ObjektVySida
          caption="Fakturabild"
          sidNr={1}
          collectionName="LRFakturaDel"
          smallScreenNoPadding
          hidden
        >
          <FakturaBilderComponent
            leverantorfaktura={getBildFaktura(
              formContext?.data?._Associations?.Faktura
            )}
            id={formContext?.data?._Associations?.Faktura?.id ?? null}
            noPadding
            useWheelToScroll
          />
        </ObjektVySida>
        <ObjektVySida
          caption="Kontering"
          sidNr={2}
          collectionName="LRFakturaDel"
          smallScreenNoPadding
          hidden
        >
          <ObjektVyKort caption="Kontering">
            <FastRegGrid id={props.id ?? ''} />
          </ObjektVyKort>
        </ObjektVySida>
      </ObjektVy>
    </EDDialog>
  );
};

export default FakturaAttestSnabbRegModal;
